import { ReactComponent as Logo } from 'assets/qfree-logo.svg';
import { Toolbar, Typography } from '@mui/material';
import { useTheme } from '@mui/styles';
import { useTranslation } from 'react-i18next';

export const PopupAppHeader = () => {
  const { t } = useTranslation('app');
  const { spacing, palette } = useTheme();
  return (
    <Toolbar
      variant='dense'
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        color: palette.primary.contrastText,
        backgroundColor: palette.primary.dark,
      }}
      disableGutters
    >
      <Logo
        style={{
          position: 'fixed',
          top: spacing(3),
          left: spacing(2),
          height: 20,
        }}
        viewBox='23 12 154 55'
        display='inline-flex'
      />
      <Typography variant='body1' noWrap>
        {t('kineticMobility')}
      </Typography>
    </Toolbar>
  );
};
